<div class="wnl-header">
  <p>
    WNL: No constipation, diarrhea or nausea. BM brown and formed. BS present and active. Full bowel
    control. Abdomen not tender to palpation. Tolerating meals well.
  </p>

  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()" class="form-container">
  <h2>Bowel Sounds</h2>
  <div class="bowel-sounds">
    <emr-input type="select" [hasWNL]="true" label="LUQ" [control]="formGroup().controls.bowelSoundsLuq"
      [options]="bowelSoundsOptions" [default]="bowelSoundsDefault" [(wnl)]="wnlManager.controlColl['luq'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />

    <emr-input type="select" [hasWNL]="true" label="RUQ" [control]="formGroup().controls.bowelSoundsRuq"
      [options]="bowelSoundsOptions" [default]="bowelSoundsDefault" [(wnl)]="wnlManager.controlColl['ruq'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />

    <emr-input type="select" [hasWNL]="true" label="LLQ" [control]="formGroup().controls.bowelSoundsLlq"
      [options]="bowelSoundsOptions" [default]="bowelSoundsDefault" [(wnl)]="wnlManager.controlColl['llq'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />

    <emr-input type="select" [hasWNL]="true" label="RLQ" [control]="formGroup().controls.bowelSoundsRlq"
      [options]="bowelSoundsOptions" [default]="bowelSoundsDefault" [(wnl)]="wnlManager.controlColl['rlq'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
  </div>

  <div class="other">
    <assessment-row title="Date of Last Bowel Movement">
      <emr-input class="assessment-input" type="date" [control]="formGroup().controls.dateLastBM" />
    </assessment-row>

    <assessment-row title="Nausea">
      <emr-checkbox [control]="formGroup().controls.nausea" label="Yes" />
    </assessment-row>

    <assessment-row title="Emesis">
      <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.emesis" [options]="emesisOptions"
        [default]="emesisDefault" [(wnl)]="wnlManager.controlColl['emesis'].wnl"
        (wnlChange)="wnlManager.updateAllWNL()" />
    </assessment-row>

    <assessment-row title="Bowel Control">
      <emr-checkbox [control]="formGroup().controls.incontinence" label="Incontinence" />
    </assessment-row>

    <h2>Ostomy</h2>
    <div class="ostomy">
      <assessment-row title="Stoma Site">
        <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.ostomyStomaSite"
          [options]="stomaSiteOptions" [default]="stomaSiteDefault" [(wnl)]="wnlManager.controlColl['stomaSite'].wnl"
          (wnlChange)="wnlManager.updateAllWNL()" />
      </assessment-row>

      <assessment-row title="Output">
        <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.ostomyOutput" [options]="outputOptions"
          [default]="outputDefault" [(wnl)]="wnlManager.controlColl['output'].wnl"
          (wnlChange)="wnlManager.updateAllWNL()" />
      </assessment-row>
    </div>

    <h2>Hemorrhoids</h2>
    <assessment-row title="Hemorrhoids">
      <emr-checkbox [control]="formGroup().controls.hemorrhoids" label="Present" />
    </assessment-row>

    <h2>Nutrition</h2>

    <assessment-row title="Reduced Appetite">
      <emr-checkbox [control]="formGroup().controls.reducedAppetite" label="Yes"></emr-checkbox>
    </assessment-row>

    <assessment-row title="Unplanned Weight loss in past 3-6 months">
      <emr-input type="select" [control]="formGroup().controls.weightLossPercentage" [options]="weightLossOptions"
        [bottomSpace]="true" width="5" />
    </assessment-row>

    <assessment-row title="Oral Diet">
      <emr-input type="select" [control]="formGroup().controls.oralDiet" [options]="oralDietOptions"
        [bottomSpace]="true" />
    </assessment-row>

    <assessment-row title="Tube Feed">
      <emr-checkbox [control]="formGroup().controls.tubeFeed" label="Yes" />
    </assessment-row>
    @if (formGroup().controls.tubeFeed.value) {
    <assessment-row title="Tube Type">
      <emr-input type="text" [control]="formGroup().controls.tubeType" />
    </assessment-row>

    <assessment-row title="How many hours since bag change?">
      <emr-input type="text" [control]="formGroup().controls.bagChangedHours" />
    </assessment-row>

    <assessment-row title="Site Assessment">
      <emr-input type="text" [control]="formGroup().controls.siteAssessment" />
    </assessment-row>
    }
    <assessment-row title="Nutrition Score" description="Sum of all points per category">
      <h3 class="fr-score">{{ nutritionRiskCategory }}</h3>
    </assessment-row>
  </div>
</div>